
// banner slider code//
function initTwoBannerSplide(scope = document) {
  scope.querySelectorAll('.banner-splide').forEach((el) => {
    if (el.classList.contains('splide--initialized')) return;

    const slides = el.querySelectorAll('.splide__slide');
    if (slides.length <= 1) return;

    const splide = new Splide(el, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      autoplay: false,
      interval: 3000,
      arrows: true,
      pagination: false,
      pauseOnHover: true,
      pauseOnFocus: true,
    });

    splide.mount();
    el.classList.add('splide--initialized');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initTwoBannerSplide();
});

document.addEventListener('shopify:section:load', (event) => {
  initTwoBannerSplide(event.target);
});
// banner slider code//

// collection list slider code //

// function initCollectionSlider(slider) {
//   if (!slider) return;


//   if (slider.classList.contains('splide--initialized')) return;

//   const slides = slider.querySelectorAll('.splide__slide');
//   if (slides.length <= 1) return;

//   const splide = new Splide(slider, {
//     type: 'slide',
//     perPage: 5,
//     // gap: '1rem',
//     pagination: false,
//     arrows: false,
//     breakpoints: {
//       989: {
//         padding: { right: 100 },
//         perPage: 2,
//       },
//       480: {
//         perPage: 1,
//       },
//     },
//   });

//   splide.mount();
//   slider.classList.add('splide--initialized');
// }


function initCollectionSlider(scope = document) {
  scope.querySelectorAll('.collection-splide').forEach((slider) => {

    // prevent double initialization
    if (slider.classList.contains('is-initialized')) return;

    new Splide(slider, {
      type: 'slide',
      perPage: 5,
      // gap: '20px',
      arrows: true,
      pagination: false,
      rewind: false,
      breakpoints: {
        1024: {
          perPage: 3,
        },
        768: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        }
      }
    }).mount();
slider.querySelectorAll('.splide__arrow').forEach((arrow) => {
      arrow.addEventListener('click', (e) => {
        if (arrow.disabled) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    });
    slider.classList.add('is-initialized');
  });
}


document.addEventListener('DOMContentLoaded', () => {
  initCollectionSlider();
});


document.addEventListener('shopify:section:load', (event) => {
  initCollectionSlider(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  initCollectionSlider(event.target);
});

// collection list slider code //



// Featured Collection Slider

function initFeaturedSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;


  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 4,
    perMove: 1,
    gap: '30px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1600: { perPage: 5 },
      1199: { perPage: 5 },
      1024: { perPage: 3, gap: '15px' },
      768: { perPage: 2.5 },
      575: {
        perPage: 1,
        perMove: 1,
        padding: { right: '0px', left: '0px' }
      },
    },
  });


  const bar = slider.querySelector('.my-carousel-progress-bar');
  if (bar) {
    splide.on('mounted move', function () {
      const end = splide.Components.Controller.getEnd() + 1;
      const rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = `${rate * 100}%`;
    });
  }


    splide.mount();



  const prevBtn = slider.querySelector('.splide__arrow--prev');
  const nextBtn = slider.querySelector('.splide__arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
  if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));

  slider.classList.add('splide--featured-initialized');
}



function autoInitFeaturedSliders(scope = document) {
  scope.querySelectorAll('.fps-splide').forEach((slider) => {
    initFeaturedSlider(slider);
  });
}


document.addEventListener('DOMContentLoaded', () => autoInitFeaturedSliders());


document.addEventListener('shopify:section:load', (event) => autoInitFeaturedSliders(event.target));
document.addEventListener('shopify:section:select', (event) => autoInitFeaturedSliders(event.target));

// Featured Collection Slider


// left image with right slider code //

function initLeftImgFeaturedSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 2,
    perMove: 1,
    gap: '30px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1024: { gap: '15px'},
      768: { perPage: 2 },
      575: { perPage: 1 }
    },
  });

  splide.mount();

  const prevBtn = slider.querySelector('.splide__arrow--prev');
  const nextBtn = slider.querySelector('.splide__arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
  if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));

  slider.classList.add('splide--featured-initialized');
}

function autoInitLeftImgSliders(scope = document) {
  scope.querySelectorAll('.i-fps-splide').forEach(slider => initLeftImgFeaturedSlider(slider));
}

document.addEventListener('DOMContentLoaded', () => autoInitLeftImgSliders());
document.addEventListener('shopify:section:load', (event) => autoInitLeftImgSliders(event.target));
document.addEventListener('shopify:section:select', (event) => autoInitLeftImgSliders(event.target));
// left image with right slider code //



// product tab info
 
 document.querySelectorAll(".cmn-tab").forEach(function (item){
      item.addEventListener("click", function(){
 
        // active class add and remove
        const tabId = this.getAttribute("data-id");
        this.classList.toggle("active");
 
         const TabParent = Array.from(this.parentElement.children);
          TabParent.forEach(function (sibling) {
            if(sibling != this){
            sibling.classList.remove("active");
            }
          }, this);
 
 
        // bottom process
 
          const nextSibling = Array.from(this.parentElement.nextElementSibling.children);
           nextSibling.forEach(function (infoItem){
                const InfoId = infoItem.getAttribute("data-id");
                if(InfoId == tabId){
                    infoItem.style.display = "block";
                    infoItem.classList.add("active");
 
                    const infoParent = Array.from(infoItem.parentElement.children);
                     infoParent.forEach(function (infoparentitem){
                        if(infoparentitem != infoItem){
                            infoparentitem.style.display = "none";
                            infoparentitem.classList.remove("active");
                        }
                     });
                 }
               
               
           });
     
 
      });
 
   });




//---------------Related Product -------------------

function relatedProductSlider(){
    
const AvailMarquee = document.querySelector('.products-available');

if (AvailMarquee) {
  const splide = new Splide(AvailMarquee, {
    type: 'slide',
    gap: '30px',
    perPage: 4,
    pagination: false,
    arrows: true,
    breakpoints: {
      989: {
        perPage: 3,
      },
      480: {
        perPage: 1,
      },
    },
  });

  splide.on('mounted move resized', function () {
    const totalSlides = splide.length;
    const index = splide.index;
    const perPage = splide.options.perPage;
    const lastIndex = totalSlides - perPage;

    const prevArrow = AvailMarquee.querySelector('.splide__arrow--prev');
    const nextArrow = AvailMarquee.querySelector('.splide__arrow--next');

    // Hide arrows only if slides fit in one view
    if (totalSlides <= perPage) {
      prevArrow.style.display = 'none';
      nextArrow.style.display = 'none';
      return;
    } else {
      prevArrow.style.display = '';
      nextArrow.style.display = '';
    }

    // Reset classes
    prevArrow.classList.remove('disabled');
    nextArrow.classList.remove('disabled');

    // Disable at first slide
    if (index === 0) {
      prevArrow.classList.add('disabled');
    }

    // Disable at last slide
    if (index >= lastIndex) {
      nextArrow.classList.add('disabled');
    }
  });

  splide.mount();
}

}





// for shop mega menu
const shopMenuItems = document.querySelectorAll('.cusMenu-shop');
const megaMenu = document.querySelector('.for-shopmega');

if (shopMenuItems.length && megaMenu) {
  shopMenuItems.forEach((item) => {
    item.appendChild(megaMenu.cloneNode(true));
    item.classList.add('has-mega-menu');
  });
}


// for shop by problem mega menu
const shopMenuItemProblem = document.querySelectorAll('.cusMenu-shop-by-problem');
const megaMenuProblem = document.querySelector('.for-shopproblemmega');

if (shopMenuItemProblem.length && megaMenuProblem) {
  shopMenuItemProblem.forEach((item) => {
    item.appendChild(megaMenuProblem.cloneNode(true));
    item.classList.add('has-mega-menu');
  });
}


document.querySelectorAll('.has-mega-menu').forEach(el => {
  el.addEventListener('mouseenter', () => el.classList.add('selected'));
  el.addEventListener('mouseleave', () => el.classList.remove('selected'));
});


// mobile mega menu click toggle
const megaMenuArrow = document.querySelectorAll(".megamenu-icon"); 
 if(megaMenuArrow){
   megaMenuArrow.forEach((item) => {
    item.addEventListener('click', function() {
      this.parentElement.classList.toggle('megamenu-active');
   });
   });
 }

 // mobile mega menu back arrow toggle
const megaMenuBackArrow = document.querySelectorAll(".back-megamenu-icon"); 
 if(megaMenuBackArrow){
   megaMenuBackArrow.forEach((item) => {
    item.addEventListener('click', function() {
      const megaMenuParent = this.closest('.has-mega-menu');
      if (megaMenuParent) {
        megaMenuParent.classList.toggle('megamenu-active');
      }
   });
   });
 }



// pdp page read more des//

 document.addEventListener('DOMContentLoaded', function () {
    const readMoreBtn = document.getElementById('read-more');
    const shortDesc = document.getElementById('short-description');
    const fullDesc = document.getElementById('full-description');

    if (!readMoreBtn || !shortDesc || !fullDesc) return;

    readMoreBtn.addEventListener('click', function (e) {
      e.preventDefault();

      const isHidden = fullDesc.classList.contains('hidden');

      if (isHidden) {
        fullDesc.classList.remove('hidden');
        shortDesc.style.display = 'none';
        readMoreBtn.innerText = 'Read Less';
      } else {
        fullDesc.classList.add('hidden');
        shortDesc.style.display = 'block';
        readMoreBtn.innerText = 'Read More';
      }
    });
  });